class SubmitSuccessController {
  constructor() {
    this.name = 'submitSuccess';
  }

  returnToOriginalForm() {
    this.isRequestCompleted = false;
  }
}

export default SubmitSuccessController;



// WEBPACK FOOTER //
// ./app/components/submitSuccess/submitSuccess.controller.js